import { render, staticRenderFns } from "./imgShow.vue?vue&type=template&id=fa96c78a&scoped=true&"
import script from "./imgShow.vue?vue&type=script&lang=js&"
export * from "./imgShow.vue?vue&type=script&lang=js&"
import style0 from "./imgShow.vue?vue&type=style&index=0&id=fa96c78a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa96c78a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
